import { observer } from "mobx-react"
import { Col, Form, FormInstance, Input, Row, Select } from "antd"

import { WhiteListIpCreate } from "@src/pages/settingsWhiteListIp/classes/WhiteLIstIpsCollection"
import { SubmitButton } from "@src/shared/componemts/SubmitButton"

export type Props = {
  form: FormInstance
  isLoading: boolean
  submit: (req: WhiteListIpCreate) => void
}
export const WhiteListIPForm = observer(
  ({ form, isLoading, submit }: Props) => {
    const ipv4CIDRRegex =
      /^(?:(?:25[0-5]|2[0-4]\d|1\d{2}|[0-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d{2}|[0-9]?\d)){3})(?:\/([0-9]|[1-2][0-9]|3[0-2]))?$/

    const ipv6CIDRRegex =
      /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|(([0-9a-fA-F]{1,4}:){1,7}:)|(([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4})|(([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2})|(([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3})|(([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4})|(([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5})|([0-9a-fA-F]{1,4}:)((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))(?:\/([0-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8]))?$/

    return (
      <Form
        form={form}
        id="GENERATED_ID_WHITELISTFORM_FORM_VOID_1"
        layout="vertical"
        name="whitelist"
        onFinish={submit}
        size="large"
      >
        <Row align="top" gutter={16}>
          <Col span={12}>
            <Form.Item
              id="GENERATED_ID_WHITELISTIPFORM_TSX_FORM.ITEM_VOID_1"
              label="IP address"
              name="address"
              rules={[
                { message: "Please input address", required: true },
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve()

                    if (
                      ipv4CIDRRegex.test(value) ||
                      ipv6CIDRRegex.test(value)
                    ) {
                      return Promise.resolve()
                    }

                    return Promise.reject(
                      new Error(
                        "Enter valid IPv4 or IPv6 address (with or without CIDR)",
                      ),
                    )
                  },
                },
              ]}
            >
              <Input placeholder="Enter address" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              id="GENERATED_ID_WHITELidsISTFORM_TSX_FORM.ITEM_VOID_2"
              label="Description"
              name="description"
            >
              <Input placeholder="Enter description" />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item
              id="GENERATED_ID_WHITELISTFORM_TSX_FORM.ITEM_VOID_4"
              label={" "}
            >
              <SubmitButton
                buttonProps={{
                  loading: isLoading,
                  size: "large",
                  type: "primary",
                }}
                form={form}
              >
                Save Address
              </SubmitButton>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  },
)
